import React from "react";
import { transformToHtml, getBackgroundImage } from "../../../utils/CommonUtils";
import { getBackgroundColor } from "../../../utils/FlightStatusUtils";

/**
 * UI-only placeholder for Aircraft/Seating/Amenities card.
 * API integration will provide real data later.
 */
export default function AircraftSeatingAmenitiesCard({ data, logEvent }) {
  if (!data?.subCardsData?.cards?.length) {
    return (
      <div className="asa-main-container">
        <div className="asa-placeholder">Aircraft & Amenities (data will load from API)</div>
      </div>
    );
  }

  const { subCardsData } = data;
  const { order = [], cards = [] } = subCardsData;

  return (
    <div
      className="asa-main-container"
      style={data?.bgColors && getBackgroundColor(data.bgColors)}
    >
      {order.map((row) => (
        <div key={row.join("-")} className="asa-row makeFlex gap16">
          {row.map((cardId) => {
            const card = cards.find((c) => c.identifier === cardId);
            if (!card?.data) return null;
            const d = card.data;
            return (
              <div
                key={cardId}
                className="asa-card br8 padding16"
                style={{
                  ...getBackgroundColor(d.bgColors || []),
                  borderColor: d.borderColors?.[0] || "#e5e5e5",
                }}
              >
                {d.title && (
                  <div className="asa-title fontSize16 appendBottom12">
                    {transformToHtml(d.title)}
                  </div>
                )}
                {d.infoList?.length > 0 && (
                  <div className="asa-info-list">
                    {d.infoList.map((item, i) => (
                      <div key={i} className="asa-info-item">
                        {item.icon && (
                          <span
                            className="asa-icon bgProperties"
                            style={{ backgroundImage: `url(${item.icon})` }}
                          />
                        )}
                        <span className="asa-info-text fontSize14">
                          {transformToHtml(item.text)}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
                {d.amenitiesInfo?.length > 0 && (
                  <div className="asa-amenities-list">
                    {d.amenitiesInfo.map((a, i) => (
                      <div key={i} className="asa-amenity-item">
                        {a.icon && (
                          <span
                            className="bgProperties icon24"
                            style={getBackgroundImage(a.icon)}
                          />
                        )}
                        <div className="flexCol">
                          {a.title && (
                            <span className="asa-amenity-text-title">
                              {transformToHtml(a.title)}
                            </span>
                          )}
                          {a.text && (
                            <span className="asa-amenity-text">
                              {transformToHtml(a.text)}
                            </span>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
}
